export default __webpack_public_path__ + "static/media/orange.decedb3a.m4a";